import { RECOMMENDED_COUNT_PER_PAGE } from "@config/quickNews";
import fetchBHApi from "@helper/fetchBHApi";
import logger from "@src/logger/Logger";
import { ProcessedArticleData } from "@transformer/useOSResponse";

type RecommendedPagination = {
  current: number;
  next: number;
  totalPages: number;
};

type RecommendationResponse = {
  data: {
    ids: string[];
  };
  pagination: RecommendedPagination;
};

type MoreArticleFeedsResponse = {
  articleIDs: string[];
  pagination: RecommendedPagination;
};

type GetArticlesByIdsApiResponse = {
  data?: ProcessedArticleData[];
};

export async function getMoreRecommendedArticleFeeds(
  page?: number,
  size?: number,
  sections?: string[],
): Promise<MoreArticleFeedsResponse> {
  const requestDataWithPagination = {
    contentType: "article",
    page: page ?? 1,
    size: size ?? RECOMMENDED_COUNT_PER_PAGE,
    sections: sections ?? [],
    getPayload: true,
  };
  let articleIDs: string[] = [];

  try {
    const recommendations = await fetchBHApi<RecommendationResponse>(
      `recommendations`,
      "POST",
      requestDataWithPagination,
    );
    articleIDs = recommendations.data.ids;
    return { articleIDs, pagination: recommendations.pagination };
  } catch {
    logger.error("Failed to fetch recommended article IDs for Quick News", {
      requestData: requestDataWithPagination,
    });
    return {
      articleIDs: [],
      pagination: { current: 0, next: 0, totalPages: 0 },
    };
  }
}

export async function getArticlesByIds(
  articleIds: string[],
): Promise<ProcessedArticleData[]> {
  try {
    const response = await fetchBHApi<GetArticlesByIdsApiResponse>(
      `get-articles`,
      "POST",
      { articleIds },
    );
    return response.data || [];
  } catch (error) {
    logger.error("Failed to fetch articles by IDs for Quick News", {
      error: (error as Error).message,
      articleIds,
    });
    return [] as ProcessedArticleData[];
  }
}
